import { render, staticRenderFns } from "./dragDialog.vue?vue&type=template&id=79f978c8"
import script from "./dragDialog.vue?vue&type=script&lang=js"
export * from "./dragDialog.vue?vue&type=script&lang=js"
import style0 from "./dragDialog.vue?vue&type=style&index=0&id=79f978c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports